function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

const progresses = {};
progresses.default = [
  {
    title: "Основная информация",
    name: "basicInfo",
    completed: false,
    fields: ["subjectKey", "lastname", "name", "nameLegal"],
    check: (values, form) => {
      switch (values.subjectKey) {
        case "legal":
          return !!(
            !hasErrors(form.getFieldsError(["nameLegal"])) && values.nameLegal
          );
        case "individ":
          return !!(
            !hasErrors(form.getFieldsError(["nameLegal"])) && values.nameLegal
          );
        case "physical":
          return !!(
            !hasErrors(form.getFieldsError(["lastname", "name"])) &&
            values.lastname &&
            values.name
          );
        default:
          return false;
      }
    },
    getDescription: values => {
      switch (values.subjectKey) {
        case "legal":
          return `ЮЛ, ${values.nameLegal}`;
        case "physical":
          return `ФЛ, ${values.lastname} ${values.name && values.name[0]}. `;
        case "individ":
          return `ИП, ${values.nameLegal}`;
        default:
          return null;
      }
    }
  },
  {
    title: "Контактные данные",
    name: "contactInformation",
    fields: ["phoneCode", "phone", "email"],
    completed: false,
    check: (values, form) => {
      return !!(
        values.phoneCode &&
        values.phone &&
        values.email &&
        !hasErrors(
          form.getFieldsError(["phoneCode", "phone", "email"])
        )
      );
    },
    getDescription: values => {
      return `${values.phoneCode}${values.phone}, ${values.email}`;
    }
  },
  {
    title: "Реквизиты банка",
    name: "bankDetails",
    fields: ["bankName0", "bankAccountNum0", "bik0", "accountCorr0"],
    completed: false,
    check: (values, form) => {
      return !!(
        !hasErrors(
          form.getFieldsError([
            "bankName0",
            "bankAccountNum0",
            "bik0",
            "accountCorr0"
          ])
        ) &&
        values.bankName0 &&
        values.bankAccountNum0 &&
        values.bik0 &&
        values.accountCorr0
      );
    },
    getDescription: values => {
      return `${values.bankName0}, ${values.bankAccountNum0}`;
    }
  }
  // {
  //   title: 'Представитель',
  //   name: 'representative',
  //   fields: [
  //     'representativeName',
  //     'representativeLastname',
  //     'representativePatronymic',
  //   ],
  //   completed: false,
  //   check: (values, form) => {
  //     return (
  //       !!!hasErrors(
  //         form.getFieldsError([
  //           'representativeName',
  //           'representativeLastname',
  //           'representativePatronymic',
  //         ])
  //       ) &&
  //       values.representativeName &&
  //       values.representativeLastname &&
  //       values.representativePatronymic
  //     );
  //   },
  //   getDescription: values => {
  //     return `${
  //       values.representativeLastname
  //     } ${values.representativeName[0].toUpperCase()}. ${values.representativePatronymic[0].toUpperCase()}.`;
  //   },
  // },
];

export default progresses;
